import { FileText, LayoutTemplate, Upload } from "lucide-react";

export function TemplateFormPlaceholder() {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 sm:p-6">
      <div className="mb-5 flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/15">
          <LayoutTemplate className="h-4.5 w-4.5 text-primary-foreground/70" />
        </div>
        <h2 className="text-base font-semibold text-foreground">Add a template</h2>
      </div>

      <div className="flex flex-col gap-4 opacity-60 pointer-events-none select-none">
        {/* Name field */}
        <div className="flex flex-col gap-1.5">
          <span className="text-sm font-medium text-foreground">Template name</span>
          <div className="flex h-10 items-center rounded-xl border border-border bg-background px-3 text-sm text-muted-foreground">
            e.g. My usual reading layout
          </div>
        </div>

        {/* Scope field */}
        <div className="flex flex-col gap-1.5">
          <span className="text-sm font-medium text-foreground">Applies to</span>
          <div className="flex h-10 items-center rounded-xl border border-border bg-background px-3 text-sm text-muted-foreground">
            Default (all lesson types)
          </div>
        </div>

        {/* File upload */}
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium text-foreground">Your lesson plan</span>
          <p className="text-xs text-muted-foreground">JPG, PNG, WebP, PDF (first two pages), or Word (.docx).</p>

          {/* Fake selected file */}
          <div className="flex items-center gap-3 rounded-xl border border-primary/25 bg-primary/8 px-3 py-2.5">
            <FileText className="h-4 w-4 shrink-0 text-primary-foreground/60" />
            <span className="text-sm text-foreground">my-lesson-plan.pdf</span>
          </div>

          {/* Drop zone */}
          <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-primary/30 bg-primary/5 px-6 py-7 text-center">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-primary/20 bg-primary/15">
              <Upload className="h-4.5 w-4.5 text-primary-foreground/70" />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground">Upload lesson plan</p>
              <p className="mt-0.5 text-xs text-muted-foreground">PDF, Word, or up to 3 images</p>
            </div>
          </div>
        </div>

        {/* Save button */}
        <div className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-accent text-sm font-semibold text-accent-foreground">
          <span className="text-base" aria-hidden>✦</span>
          Save template
        </div>
      </div>
    </div>
  );
}
